import React from 'react';
import loadingBlue from '../../assets/img/grid-loading-blue.svg';
import loadingRed from '../../assets/img/grid-loading-red.svg';
import loadingGray from '../../assets/img/grid-loading-gray.svg';
import loadingDarkGray from '../../assets/img/grid-loading-dark-gray.svg';
import './LoadingStyle.css';

type loaderColor = 'red' | 'blue' | 'darkGray' | 'gray';

interface LoaderProps {
	transform?: number;
	height?: number;
	width?: number;
	color?: loaderColor;
}

const getCurrentLoaderColor = (color: loaderColor): loaderColor => {
	if (color === 'blue') return loadingBlue;
	if (color === 'gray') return loadingGray;
	if (color === 'darkGray') return loadingDarkGray;
	return loadingRed;
};

const LoadingBlue = ({ transform, height, width, color }: LoaderProps) => {
	const transformValue = transform ? transform : '0.5';
	const heightValue = height ? height : 'auto';
	const widthValue = width ? width : 'auto';
	const currentColor = getCurrentLoaderColor(color);

	return (
		<img
			data-testid='loader'
			src={currentColor}
			style={{
				transform: 'scale(' + transformValue + ')',
				height: heightValue + 'px',
				width: widthValue + 'px',
			}}
			alt='loading'
		/>
	);
};

export default LoadingBlue;
